import LocationListHeader from "./LocationListHeader";
import LocationListRow from "./LocationListRow";
import MemorialIcon from "!!raw-loader!../../assets/icons/memorial.svg";
import CenterIcon from "!!raw-loader!../../assets/icons/center.svg";
import locationService from "../../lib/location";

export default function LocationPageIndexList({ locations, header, labels }) {
  const locationsGroupedAlphabetically = locationService.groupAlphabetically(locations);
  const letters = Object.keys(locationsGroupedAlphabetically);

  return (
    <div>
      <LocationListHeader
        letters={letters}
        header={header}
        centersLabel={labels["centers"]}
        pohLabel={labels["places-of-home"]}
        memorialsLabel={labels["memorials"]}
        centerIcon={CenterIcon}
        memorialIcon={MemorialIcon}
      />
      {letters.map((key) => {
        const group = locationsGroupedAlphabetically[key];
        return (
          <LocationListRow
            letter={key}
            locations={group}
            key={key}
            centerIcon={CenterIcon}
            memorialIcon={MemorialIcon}
          />
        );
      })}
    </div>
  );
}
